import React from 'react';
import PrepayApp from './PrepayApp';

export default <PrepayApp />;
